import styles from "./DashboardTopCard.module.scss";
import React from "react";
import arrowUpIcon from "../../../assets/images/icons/arrow-up-green.svg";
import arrowDownIcon from "../../../assets/images/icons/arrow-down-red.svg";
import { StatisticTotalItemDirection } from "../../../models/Statistics";

interface DashboardTopCardProps {
  title: string;
  value: string | number;
  percentValue: string | number;
  percentValueType: StatisticTotalItemDirection;
}

const DashboardTopCard: React.FC<DashboardTopCardProps> = ({
  title,
  value,
  percentValue,
  percentValueType,
}) => {
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.row}>
        <h4>{value}</h4>
        <div
          className={
            percentValueType === "up"
              ? styles.up
              : percentValueType === "down"
                ? styles.down
                : styles.neutral
          }
        >
          {percentValue}
          {percentValue !== 0 && "%"}
          {percentValueType === "down" ? (
            <img src={arrowDownIcon} alt={"down"} />
          ) : percentValueType === "up" ? (
            <img src={arrowUpIcon} alt={"up"} />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardTopCard;
